module.exports = __webpack_public_path__ + "img/antes_despues_66.ede87912.png";